<div class="wm-project-changes popover-content popover" aria-haspopup="true" *ngIf="projectUpdatesService.showUpdatesAvailableNotification">
  <div class="popover-indicator"></div>
  <p>{{locale.MESSAGE_NEW_UPDATES}}</p>
  <div class="button-row">
    <button class="app-button btn btn-primary"
            (click)="$event.stopPropagation(); dropdown.show(); projectUpdatesService.showUpdatesAvailableNotification = false">{{locale.LABEL_PROPERTY_VIEW}}</button>
    <button class="btn-default btn app-button"
            (click)="dropdown.hide(); projectUpdatesService.showUpdatesAvailableNotification = false">{{locale.LABLE_DISMISS}}</button>
  </div>
</div>
